import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  EVENT_ITEM_PLAN,
  EVENT_ITEM_PLAN_PRIORITY,
} from '../../../../../constants/event-items';
import WeddingEventComparisonItem from './WeddingEventComparisonItem';
import {
  EVENT_ITEM_FEATURE,
  EVENT_ITEM_FEATURE_LABELS,
  EVENT_ITEM_FEATURE_META,
} from '../helpers';
import CheckmarkIcon from '../../../../../components/icons/CheckmarkIcon';
import CloseIcon from '../../../../../components/icons/CloseIcon';

const propTypes = {
  weddingEventItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      plan: PropTypes.string,
    }),
  ),
  paidPlansOnly: PropTypes.bool,
  onSelectPlan: PropTypes.func,
  activePurchasedEvent: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const WeddingEventComparison = ({
  weddingEventItems,
  paidPlansOnly,
  onSelectPlan,
  activePurchasedEvent,
}) => {
  const freePlan = paidPlansOnly
    ? null
    : weddingEventItems.find(
        eventItem => eventItem.plan === EVENT_ITEM_PLAN.FREE,
      );
  const basicPlan = weddingEventItems.find(
    eventItem => eventItem.plan === EVENT_ITEM_PLAN.BASIC,
  );
  const premiumPlan = weddingEventItems.find(
    eventItem => eventItem.plan === EVENT_ITEM_PLAN.PREMIUM,
  );

  const eventItemFeatureKeys = Object.values(EVENT_ITEM_FEATURE);

  const displayFreePlan =
    !activePurchasedEvent ||
    EVENT_ITEM_PLAN_PRIORITY[freePlan.plan] >=
      EVENT_ITEM_PLAN_PRIORITY[activePurchasedEvent.plan];

  const displayBasicPlan =
    !activePurchasedEvent ||
    EVENT_ITEM_PLAN_PRIORITY[basicPlan.plan] >=
      EVENT_ITEM_PLAN_PRIORITY[activePurchasedEvent.plan];

  return (
    <div className="table-responsive horizontal-scroller wedding-event-comparison-table">
      <table className="table table-striped table-transparent-header mb-3">
        <thead>
          <tr>
            <th colSpan={1}>&nbsp;</th> {/** Features. */}
            <th>
              <WeddingEventComparisonItem
                eventItem={premiumPlan}
                onSelectPlan={onSelectPlan}
                active={activePurchasedEvent?.plan === premiumPlan.plan}
              />
            </th>
            {displayBasicPlan && (
              <th>
                <WeddingEventComparisonItem
                  eventItem={basicPlan}
                  onSelectPlan={onSelectPlan}
                  active={activePurchasedEvent?.plan === basicPlan.plan}
                />
              </th>
            )}
            {freePlan && displayFreePlan && (
              <th>
                <WeddingEventComparisonItem
                  eventItem={freePlan}
                  onSelectPlan={onSelectPlan}
                  active={activePurchasedEvent?.plan === freePlan.plan}
                />
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {eventItemFeatureKeys.map(key => {
            const premiumPlanValue =
              EVENT_ITEM_FEATURE_META[premiumPlan.plan][key];
            const basicPlanValue = EVENT_ITEM_FEATURE_META[basicPlan.plan][key];
            const freePlanValue = EVENT_ITEM_FEATURE_META[freePlan?.plan][key];

            const getValueComponent = value => (
              <>
                {typeof value === 'boolean' ? (
                  <>
                    {value && <CheckmarkIcon />}
                    {!value && <CloseIcon color="#B5BCBD" />}
                  </>
                ) : (
                  <>{value}</>
                )}
              </>
            );

            return (
              <tr key={key}>
                <td colSpan={1} className="text-left">
                  {EVENT_ITEM_FEATURE_LABELS[key]}
                </td>
                <td>{getValueComponent(premiumPlanValue)}</td>
                {displayBasicPlan && (
                  <td>{getValueComponent(basicPlanValue)}</td>
                )}
                {freePlan && displayFreePlan && (
                  <td>{getValueComponent(freePlanValue)}</td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

WeddingEventComparison.propTypes = propTypes;

export default WeddingEventComparison;
